module.exports = __webpack_public_path__ + "images/hundredDAU-f0a4ed213378aa229c2964b9cad60530.svg";